module.exports = __webpack_public_path__ + "static/media/kapsalon.1201df11.jpeg";